import React, { Suspense, lazy } from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Navigate, Route, Routes, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Landing } from "./landing/Landing";
import { Impressum, Datenschutz, Nutzungsbedingungen, Auftragsverarbeitung, Barrierefreiheit } from "./landing/Legal";
import { PrivacyLayer } from "./lib/consent";
import { Wordmark } from "./kater/ui";

const AdminRoot = lazy(() => import("./admin/AdminRoot"));
// the app (PDF reader, engine, maps) loads only when needed: the landing page stays small
const AppRoot = lazy(() => import("./app/AppRoot").then((m) => ({ default: m.AppRoot })));
const Demo = lazy(() => import("./kater/Demo").then((m) => ({ default: m.Demo })));
/** Unknown address: say so and offer the way back. */
/** A new page starts at its top (the browser keeps the old scroll position on client-side navigation). */
function ScrollTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

function NotFound() {
  React.useEffect(() => { document.title = "Seite nicht gefunden – NebenkostenKater"; }, []);
  return (<div className="shell paper"><header className="topbar"><a href="/" aria-label="NebenkostenKater – zur Startseite"><Wordmark size={40} /></a></header>
    <main className="up" id="main" style={{ maxWidth: 520 }}>
    <img className="kater" src="/brand/kater/kater-192.webp" width={96} height={96} alt="" style={{ borderRadius: "50%" }} />
    <h1 tabIndex={-1} ref={(el) => el?.focus({ preventScroll: true })}>Diese Seite gibt es nicht.</h1>
    <p className="sub">Vielleicht hat sich ein Tippfehler in die Adresse geschlichen.</p>
    <div className="row" style={{ marginTop: 16 }}><a className="btn btn-primary" href="/app" style={{ textDecoration: "none" }}>Zu meinen Abrechnungen</a><a className="btn btn-quiet" href="/" style={{ textDecoration: "none" }}>Zur Startseite</a></div>
  </main></div>);
}
const Wait = () => <div className="shell"><p className="sub" role="status" style={{ marginTop: 40 }}>Lädt …</p></div>;


ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <BrowserRouter>
      <ScrollTop />
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/impressum" element={<Impressum />} />
        <Route path="/datenschutz" element={<Datenschutz />} />
        <Route path="/nutzungsbedingungen" element={<Nutzungsbedingungen />} />
        <Route path="/agb" element={<Navigate to="/nutzungsbedingungen" replace />} />
        <Route path="/auftragsverarbeitung" element={<Auftragsverarbeitung />} />
        <Route path="/avv" element={<Navigate to="/auftragsverarbeitung" replace />} />
        <Route path="/barrierefreiheit" element={<Barrierefreiheit />} />
        <Route path="/beispiel/*" element={<Suspense fallback={<Wait />}><Demo /></Suspense>} />
        <Route path="/app/*" element={<Suspense fallback={<Wait />}><AppRoot /></Suspense>} />
        <Route path="/admin/*" element={<Suspense fallback={null}><AdminRoot /></Suspense>} />
        <Route path="*" element={<NotFound />} />
      </Routes>
      <PrivacyLayer />
    </BrowserRouter>
  </React.StrictMode>,
);
